export const columns = function () {
    return [
		{
		    prop: 'insBillId',
		    label: '流水号',
		    minWidth: 100
		},
		{
		    prop: 'bh',
		    label: '单号',
		    minWidth: 150
		},
		{
		    prop: 'orgName',
		    label: '机构名称',
		    minWidth: 150
		},
		{
		    prop: 'carNo',
		    label: '车牌号',
		    minWidth: 100
		},
		{
		    prop: 'vin',
		    label: '车架号',
		    minWidth: 150
		},
		{
		    prop: 'carType',
		    label: '车型',
		    minWidth: 100
		},
		{
		    prop: 'engineNo',
		    label: '发动机号',
		    minWidth: 100
		},
		{
		    prop: 'personName',
		    label: '被服人',
		    minWidth: 100
		},
		{
		    prop: 'beginTime',
		    label: '服务起期',
			sortable: true,
		    minWidth: 150
		},
		{
		    prop: 'endTime',
		    label: '服务止期',
			sortable: true,
		    minWidth: 150
		},
        {
            prop: 'status',
            label: '状态',
            minWidth: 100,
        	render: ({ status }) => {
        	    return (this.$emun.status.find(item => item.value === status)).label || '-'
        	}
        },
		{
		    prop: 'customerFee',
		    label: '应交费用（元）',
		    minWidth: 150
		},
		{
		    prop: 'stopDay',
		    label: '暂停天数',
		    minWidth: 100
		},
		{
		    prop: 'serviceDay',
		    label: '服务天数',
		    minWidth: 100
		},
		{
		    prop: 'useDay',
		    label: '已使用天数',
		    minWidth: 100
		},
		{
		    prop: 'useMoney',
		    label: '已使用金额（元）',
		    minWidth: 150
		}
    ]
}

export default {}